import React from 'react';

const AdTrackerButton = ({ onClick }) => {
  return (
    <div className="d-block d-md-none text-center mt-2">
      <button
        type="button"
        className="btn btn-primary radius-20 mt-20 justify-content-center"
        onClick={onClick}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <img
          src={require("../../assets/images/view_white.svg")} // Fixed icon path
          alt="Ad Icon"
          className="mr-2"
          style={{ width: '20px', height: '20px' }}
        />
        Ad Tracker
      </button>
    </div>
  );
};

export default AdTrackerButton;
